var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('render-content',{attrs:{"id":"scores"}}),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items}}),_c('export',{attrs:{"columns":_vm.headers,"rows":_vm.items,"name":"dma-data","text":"Download"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }